import './App.css';
import { Route, Routes } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';

import { AuthProvider } from './hooks/use-auth';
import { ToastProvider } from './components/toast';

// Eager: home is the LCP entry, keep it in the main bundle
import NewHomePage from './pages/new-home';

// Lazy-loaded routes (code splitting → meilleur FCP/LCP, moins de JS bloquant)
const Home = lazy(() => import('./pages/home'));
const SmartInbox = lazy(() => import('./pages/smart-inbox'));
const ChatbotIndustrie = lazy(() => import('./pages/chatbot-industrie'));
const ChatbotPage = lazy(() => import('./pages/chatbot'));
const ChatbotPublicPage = lazy(() => import('./pages/chatbot/ChatbotPublicPage'));
const ChatbotMiniPage = lazy(() => import('./pages/chatbot-mini'));
const ChatbotMiniPublicPage = lazy(() => import('./pages/chatbot-mini/ChatbotMiniPublicPage'));
const ConfigurePage = lazy(() => import('./pages/configure'));
const OnboardingPage = lazy(() => import('./pages/onboarding'));
const DashboardPage = lazy(() => import('./pages/dashboard'));
const AdminDashboardPage = lazy(() => import('./pages/admin-dashboard'));
const ResetPasswordPage = lazy(() => import('./pages/reset-password'));
const ConnexionPage = lazy(() => import('./pages/connexion'));
const VideoScrubbingPage = lazy(() => import('./pages/video-scrubbing'));
const SupportClient247Page = lazy(() => import('./pages/support-client-24-7'));
const TarifsPage = lazy(() => import('./pages/tarifs'));
const BlogPage = lazy(() => import('./pages/blog'));
const SecuritePage = lazy(() => import('./pages/securite'));
const SecteursPage = lazy(() => import('./pages/secteurs'));
const TourismeLoisirsPage = lazy(() => import('./pages/secteurs/tourisme-loisirs'));
const IndustriePage = lazy(() => import('./pages/secteurs/industrie'));
const ServicesImmobilierPage = lazy(() => import('./pages/secteurs/services-immobilier'));
const AgentCommercialPage = lazy(() => import('./pages/solutions/agent-commercial'));
const SavTechniquePage = lazy(() => import('./pages/solutions/sav-technique'));
const SupportInternePage = lazy(() => import('./pages/solutions/support-interne'));
const CreationVisuelleIaPage = lazy(() => import('./pages/creation-visuelle-ia'));
const OrchestrateurMultiAgentsPage = lazy(() => import('./pages/solutions/orchestrateur-multi-agents'));
const NotFoundPage = lazy(() => import('./pages/not-found'));

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			retry: 1,
		},
	},
});

function App() {
	return (
		<HelmetProvider>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<ToastProvider>
						<div className="App">
							<Suspense fallback={null}>
								<Routes>
									<Route path="/" element={<NewHomePage />} />
									<Route path='/chatbot-maestro' element={<Home />} />
									<Route path='/chatbot' element={<ChatbotPage />} />
									<Route path='/chatbot/:slug' element={<ChatbotPublicPage />} />
									<Route path='/chatbot-mini' element={<ChatbotMiniPage />} />
									<Route path='/chatbot-mini/:slug' element={<ChatbotMiniPublicPage />} />
									<Route path='/dashboard' element={<DashboardPage />} />
									<Route path='/admin-dashboard' element={<AdminDashboardPage />} />
									<Route path='/smart-inbox' element={<SmartInbox />} />
									<Route path='/chatbot-industrie' element={<ChatbotIndustrie />} />
									<Route path='/configurer' element={<ConfigurePage />} />
									<Route path='/smartinbox' element={<ConfigurePage />} />
									<Route path='/onboarding' element={<OnboardingPage />} />
									<Route path='/reset-password' element={<ResetPasswordPage />} />
									<Route path='/connexion' element={<ConnexionPage />} />
									<Route path='/video-scrubbing' element={<VideoScrubbingPage />} />
									<Route path='/solutions/support-client-24-7' element={<SupportClient247Page />} />
									<Route path='/tarifs' element={<TarifsPage />} />
									<Route path='/blog' element={<BlogPage />} />
									<Route path='/securite' element={<SecuritePage />} />
									<Route path='/secteurs' element={<SecteursPage />} />
									<Route path='/secteurs/tourisme-loisirs' element={<TourismeLoisirsPage />} />
									<Route path='/secteurs/industrie' element={<IndustriePage />} />
									<Route path='/secteurs/services-immobilier' element={<ServicesImmobilierPage />} />
									<Route path='/solutions/agent-commercial' element={<AgentCommercialPage />} />
									<Route path='/solutions/sav-technique' element={<SavTechniquePage />} />
									<Route path='/solutions/support-interne' element={<SupportInternePage />} />
									<Route path='/solutions/orchestrateur-multi-agents' element={<OrchestrateurMultiAgentsPage />} />
									<Route path='/solutions/creation-visuelle-ia' element={<CreationVisuelleIaPage />} />
									<Route path='*' element={<NotFoundPage />} />
								</Routes>
							</Suspense>
						</div>
					</ToastProvider>
				</AuthProvider>
			</QueryClientProvider>
		</HelmetProvider>
	);
}

export default App;
